import _ from 'lodash';
import { Emitter, type Event } from '@patsnap/tahiti-core/common/event';

export interface AbstractModel<ModelData = any> {
    _modelData: ModelData;
    readonly modelData: ModelData;
    update: (getUpdateValue: (value: ModelData) => ModelData) => void;
    readonly onStatesChange: Event<ModelData>;
    clone: (value: ModelData) => ModelData;
}

export abstract class AbstractModelImpl<ModelData = any> implements AbstractModel<ModelData> {
    abstract _modelData: ModelData;
    private _onStatesChangeEmitter = new Emitter<ModelData>();
    public readonly onStatesChange = this._onStatesChangeEmitter.event;

    clone(value: ModelData): ModelData {
        return _.cloneDeep(value) as ModelData;
    }

    get modelData(): ModelData {
        return this.clone(this._modelData);
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.modelData);
    }

    private _update(value: ModelData) {
        this._modelData = value;
    }

    public update(getUpdateValue: (value: ModelData) => ModelData) {
        this._update(getUpdateValue(this.modelData));
        this._emitModelDataChange();
    }
}
